export default __webpack_public_path__ + "static/media/fitnessTracker.1167ffc6.PNG";